// 必要なReactフックとMaterial-UIコンポーネントをインポート
import { useState, useEffect, useRef, useLayoutEffect } from 'react'; // Reactのフック
import { Container, Box, Grid, Button } from '@mui/material'; // Material-UIのレイアウト用コンポーネント
import Textarea from '@mui/joy/Textarea'; // Material-UIのテキストエリア
import ChatBubble, { IChat } from '../molecules/ChatBubble'; // チャットバブル表示用のカスタムコンポーネント

/** 
 * UserChatコンポーネント
 * チャット画面のUIを構築し、ユーザーと担当者のチャット内容を表示・送信する。
 * @param {number} height - チャット表示部分の最大高さ
 */
const UserChat = ({ height }: { height: number }) => {
    // チャットの最大表示高さ（px単位）
    const maxHeight = height + "px";

    // ユーザー名
    const user = "自分";

    // チャットデータを管理するステート
    const [chat, setChat] = useState<IChat[]>([
        { from: "担当者", text: "そもさん", date: "8/1", time: "9:10", read: true },
        { from: "自分", text: "説破。", date: "8/1", time: "9:11", read: true },
        { from: "担当者", text: "むかしむかしあるところに、おじいさんとおばあさんがいました。\r\n おじいさんは山へ芝刈りに、おばあさんは川へ選択に行きました。すると、川からは大きな桃がドンブラコドンブラこと流れてきたり来なかったり。", date: "8/1", time: "09:11", read: true },
        { from: "自分", text: "どんぶらこ、どんぶらこ", date: "8/1", time: "9:12", read: true },
        { from: "自分", text: "どんぶらこ、", date: "8/1", time: "9:14", read: true },
        { from: "担当者", text: "どんぶらこ\nどんぶらこ\nどんぶらこ", date: "8/1", time: "9:15", read: true },
    ]);

    // チャットの一番下にスクロールするための参照を管理
    const scrollBottomRef = useRef<HTMLDivElement>(null);

    // 入力中のテキストを管理するステート
    const [writingText, setWritingText] = useState<string>("");

    // 「送信」ボタンを押したときの処理
    const onClick = () => {
        if (writingText !== "") {
            const now = new Date();
            // 新しいチャットを追加
            setChat([
                ...chat,
                {
                    from: user, // 送信者はユーザー
                    text: writingText, // 入力されたテキスト
                    date: String(now.getMonth() + 1).concat("/").concat(String(now.getDate())), // 現在の日付
                    time: String(now.getHours()).concat(":").concat("00".concat(String(now.getMinutes())).slice(-2)), // 現在の時間
                    read: false, // 初期状態では未読
                },
            ]);
            // 入力フィールドをクリア
            setWritingText("");
        }
    };

    // チャットが追加されるたびに一番下にスクロールする
    useLayoutEffect(() => {
        scrollBottomRef?.current?.scrollIntoView(); // 最下部にスクロール
    }, [chat]);

    // コンポーネントの描画部分
    return (
        <Box sx={{ backgroundColor: '#DDDDFF' }}>
            {/* チャット表示部分 */}
            <Box
                minHeight="50px" // 最小高さ
                maxHeight={maxHeight} // 最大高さ（外部から指定）
                sx={{ overflowY: 'scroll' }} // 縦スクロール可能
            >
                {/* チャットメッセージを1つずつ表示 */}
                {chat.map((item, index) => (
                    <ChatBubble key={index} chat={item} user={user} /> // ChatBubbleコンポーネントにデータを渡す
                ))}
                {/* 一番下のダミー要素（スクロール用） */}
                <div id="chatBottom" ref={scrollBottomRef} />
            </Box>
            {/* 入力エリアと送信ボタン */}
            <Grid container sx={{ backgroundColor: '#CCCCE0' }}>
                {/* テキスト入力エリア */}
                <Grid item xs={10} padding="10px">
                    <Textarea
                        minRows={2} // 最小行数
                        maxRows={3} // 最大行数
                        variant="soft" // 柔らかな見た目のスタイル
                        onChange={(e) => setWritingText(e.target.value)} // 入力値をステートに保存
                        value={writingText} // 入力値をバインド
                    />
                </Grid>
                {/* 送信ボタン */}
                <Grid item xs={2} padding="10px">
                    <Button onClick={onClick} variant="contained" sx={{ marginTop: '20px' }}>
                        送信
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

// UserChatコンポーネントをデフォルトエクスポート
export default UserChat;
